import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { supabase } from '@/lib/supabase'
import { qk } from '@/lib/query-client'
import { useWorkspace } from '@/providers/workspace-provider'
import { useAuth } from '@/providers/auth-provider'
import type { Tables } from '@/types/database'

export function useNotifications() {
  const { workspaceId } = useWorkspace()
  const { user } = useAuth()
  return useQuery({
    queryKey: qk.notifications(workspaceId ?? 'none'),
    enabled: !!workspaceId && !!user,
    queryFn: async (): Promise<Tables<'notifications'>[]> => {
      const { data, error } = await supabase
        .from('notifications')
        .select('*')
        .eq('workspace_id', workspaceId!)
        .order('created_at', { ascending: false })
        .limit(50)
      if (error) throw error
      return data ?? []
    },
  })
}

export function useMarkNotificationRead() {
  const { workspaceId } = useWorkspace()
  const qc = useQueryClient()
  return useMutation({
    mutationFn: async (id: string | 'all') => {
      const q = supabase.from('notifications').update({ is_read: true })
      const { error } = id === 'all' ? await q.eq('is_read', false) : await q.eq('id', id)
      if (error) throw error
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: qk.notifications(workspaceId ?? 'none') }),
  })
}
